import React from "react";
import "./Header.css";

function Header () {
    return (
        <div className="header">
            <h1>Employee Directory</h1>
            <p>Click on name heading to filter or use the search box to narrow your results</p>
        </div>
    )
}

export default Header;